import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=20060627"
import script from "./Cards.vue?vue&type=script&lang=js"
export * from "./Cards.vue?vue&type=script&lang=js"
import style0 from "./Cards.vue?vue&type=style&index=0&id=20060627&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports